import React from "react";
import logo from "./../../assets/icons/logo.svg";

// material-ui
import { ButtonBase } from "@mui/material";
import { SxProps } from "@mui/system";

export interface Props {
  sx?: SxProps;
  to: string;
}

const LogoSection = ({ sx, to }: Props) => (
  <ButtonBase
    disableRipple
    onClick={() => (window.location.href = to)}
    sx={{
      ...sx,
      overflow: "hidden",
      display: "flex",
      justifyContent: "start",
      pl: 0.5,
    }}>
    <img src={logo} alt="Weberlo" width="160" />
  </ButtonBase>
);

export default LogoSection;
